import '@/assets/styles/index.scss';

import {initBotId} from 'botid/client/core';
import React from 'react';

import {LoadingManagerProvider} from '@/objects/LoadingManager';

export const onClientEntry = () => {
    initBotId({
        protect: [
            {path: '/api/contact', method: 'POST'},
            {path: '/api/newsletter', method: 'POST'},
        ],
    });
};

export const wrapRootElement = ({element}) => (<LoadingManagerProvider>
    {element}
</LoadingManagerProvider>);

export const shouldUpdateScroll = () => {
    window.scrollTo({top: 0, left: 0, behavior: 'auto'});
    return false;
};
